import { useQuery } from "react-query"
import customAxios from "../../utils/customAxios"
import { useRecoilValue } from "recoil"
import quizPreinfoState from "../../recoil/quizPreinfo"
import { useCookies } from "react-cookie"
import useHttpErrorHandler from "../useHttpErrorHandler"
import useQuizApiErrorHandler from "../useQuizApiErrorHandler"
import { isLoggedInState } from "../../recoil/auth/atom"

const axios = customAxios()

interface QuizStartParamsType {
  sessionId: string
  userName: string
  major: string
  detailedMajor: string
}

const fetchQuizStart = ({ queryKey }: any) => {
  const params: QuizStartParamsType = queryKey[1]

  return axios.get(
    `/acadquiz/start?session_id=${params.sessionId}&user_name=${params.userName}&major=${params.major}&detailedMajor=${params.detailedMajor}`
  )
}

export const useQuizStart = () => {
  const preinfo = useRecoilValue(quizPreinfoState)
  const isLoggedIn = useRecoilValue(isLoggedInState)
  const [cookie] = useCookies(["quizRound", "quizSessionId", "email"])

  const { quizApiErrorHandler } = useQuizApiErrorHandler()
  const { httpErrorHandler } = useHttpErrorHandler(quizApiErrorHandler)

  const params: QuizStartParamsType = {
    sessionId: cookie.quizSessionId,
    userName: isLoggedIn ? cookie.email : "anonymous",
    major: preinfo.major,
    detailedMajor: preinfo.detailedMajor,
  }

  const select = (response: any) => {
    return response.data
  }

  return useQuery(["quizStart", params], fetchQuizStart, {
    staleTime: 100000,
    select,
    onError: httpErrorHandler,
    refetchOnWindowFocus: false,
    enabled: false,
  })
}
